module.exports = __webpack_public_path__ + "static/media/facebook.8fad02bc.svg";